import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import {
  BaseFormFieldComponent,
  baseProviderComponent,
} from '../base-form-field.component';
import { LocalizationPipe } from '@shared/modules/localization';

@Component({
  selector: 'ui-form-password',
  templateUrl: './form-password.component.html',
  styleUrl: './form-password.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NzFormModule, NzInputModule, NzIconModule, LocalizationPipe],
  providers: baseProviderComponent(UIFormPassword),
})
export class UIFormPassword extends BaseFormFieldComponent {
  @Input() override value?: string = '';

  passwordVisible = false;

  onBlur(): void {
    this.onTouched();
  }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
    this.updateControlValidity(); // Ensure control state is updated
  }
}
